import { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Box, Paper, Typography,
    Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
 } from "@mui/material";
 import CheckIcon from '@mui/icons-material/Check';
import { Link } from 'react-router-dom';  // Corrected import
import CreateAccount from "./steps/createaccount";
import AccountInfo from "./steps/accountinfo";
import BillingRedirect from "./steps/billingredirect";

import MoneyBackGuaranteeImage from "../../images/website-images/money-back-guarantee.png"
import SecuredImage from "../../images/website-images/secured.png"
import CancelAnyTimeImage from "../../images/website-images/cancel-any-time.png"

import { darken, lighten } from '@mui/material/styles';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useLocation } from "react-router-dom";

import { doc, getDoc } from "firebase/firestore";

import { useNavigate } from 'react-router-dom';

import {db} from '../../firebaseConfig';

import appLogo from "../../images/website-images/logos/app-logo.png";

const steps = ["Create Account", "Account Information", "Billing"];

export default function Subscribe() {
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    fullName:"",
    companyName: "",
    phone: "",
    termsAccepted: false,
    plan: "",
    frequency : "",
    accountNumber:""
  });

  const [openAcountHasEmailPasswordLoginDialog, setOpenAcountHasEmailPasswordLoginDialog] = useState(false);

  const [presetCreateAccountFormType, setPresetCreateAccountFormType] = useState("signup");

  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState(""); 
  
  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const planParam = searchParams.get("plan") || "lite";
    const frequencyParam = searchParams.get("frequency") || "monthly";

    setFormData((prev) => ({
      ...prev,
      plan: planParam.toLowerCase(),
      frequency: frequencyParam.toLowerCase()
    }));
  }, [location.search]);
  
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setActiveStep(1);
        setIsUserAuthenticated(true);
        setUserEmail(user.email);
  
        //Prevent member users from going to /subscribe

        (async () => {
          const uid = user.uid; // Use `user.uid` here
          const userDocRef = doc(db, "appUsers", uid);
          const userSnapshot = await getDoc(userDocRef);
  
          if (!userSnapshot.exists()) return;
  
          const userData = userSnapshot.data();
          
          if (userData.role === "member")
          {
            navigate('/pricing')    //members can't get to subscribe

          } else if (userData.role === "admin") 
          {
            const acctDocRef = doc(db, "appAccounts", userData.accountNumber);
            const acctSnapshot = await getDoc(acctDocRef);
    
            if (!acctSnapshot.exists()) return;
    
            const acctData = acctSnapshot.data();
            
            if (acctData.subscriptionType === "paid" && acctData.status === "active")
            {
              navigate('/pricing') //admin members on paid accounts can't go to subscribe anymore, they are already subscribed, they can only manage subscriptions from this point on
            }
          }
          
        })();
      } else {
        setActiveStep(0);
        setIsUserAuthenticated(false);
        setUserEmail("");
      }
    });
  
    return () => unsubscribe(); // Cleanup listener
  }, []);
  
  

    useEffect(() => {
  
       formData.companyName = "";
       formData.phone = "";
  
    }, [activeStep]);
  
    
  
  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleDataChange = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
  };


  const displayUserAlreadyHasPasswordLoginWithEmail = () => {
    setPresetCreateAccountFormType("signin");
    setActiveStep(0);
    setOpenAcountHasEmailPasswordLoginDialog(true);
  };

  return (

    <Box
    sx={{
      backgroundColor: '#f9f9f9' 
    }}
  >

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" }, // 1 column on mobile, 2 on md+
            gap: 4,
            p: 4,
            alignItems: "start", // Align items to top
            minHeight: "90vh",

          }}
        >

          {/* Left Column: Value Prop Text */}
          <Box sx={{ maxWidth: 400 }}>

             <Box>


        <a href="/">
              <div style={{textAlign:'center', paddingBottom:'10px'}}>
                <img src={appLogo} style={{height:'85px',cursor:'pointer',paddingBottom:"15px"}}/><br></br>
                <div style={{fontWeight:'16px'}}><b>GoTailo<sup style={{fontSize:'12px'}}>&#174;</sup></b></div>
              </div>
            </a>

             </Box>
            <Typography variant="h4" gutterBottom>
              Unlock Unmatched Success for Your Tailor.
            </Typography>
            <Box sx={{ display: { xs: "none", md: "block" } }}>
                <Typography variant="body1" paragraph>
                  <CheckIcon /> Customize services, staff roles, and performance metrics to suit your business's unique needs and operational goals.
                </Typography>
                <Typography variant="body1" paragraph>
                  <CheckIcon /> Gain insights into customer feedback, appointment schedules, and staff performance metrics with detailed dashboards.
                </Typography>
                <Typography variant="body1" paragraph>
                  <CheckIcon /> Manage orders, payments, and tailor pricing strategies with real-time financial data and payment status updates.
                </Typography>
            </Box>
          </Box>
      
          {/* Right Column: Paper Form */}
          <Paper
            elevation={3}
            sx={{
              p: 3,
              maxWidth: { xs: 360, md: 600 },
              width: "100%",
              justifySelf: "center", // centers horizontally in grid cell
            }}
          >
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel
                      sx={{
                        '& .MuiStepIcon-root': {
                          color: '#999', // Default circle color (inactive)
                        },
                        '& .MuiStepIcon-root.Mui-active': {
                          color: '#4CAF50', // Active step color //lighten('#1B263B',0.1)
                        },
                        '& .MuiStepIcon-root.Mui-completed': {
                          color: '#4CAF50', // Completed step color
                        },
                      }}
                    >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
      
            {activeStep === 0 && (
              <CreateAccount
                data={formData}
                isUserAuthenticated={isUserAuthenticated}
                userEmail={userEmail}
                onNext={handleNext} 
                displayUserAlreadyHasPasswordLoginWithEmail={displayUserAlreadyHasPasswordLoginWithEmail} 
                presetCreateAccountFormType={presetCreateAccountFormType}
                onChange={handleDataChange}
              />
            )}
            {activeStep === 1 && (
              <AccountInfo
                data={formData}
                onNext={handleNext}
                onBack={handleBack}
                onChange={handleDataChange}
                activeStep={activeStep}
              />
            )}
            {activeStep === 2 && <BillingRedirect data={formData}/>}
          </Paper>

          {/* Right Column: Placeholder */}
          <Box>
            <Typography variant="h6">
              &nbsp;
            </Typography>
          </Box>
      
          {/* Footer Links - Full width below grid */}
          <Box
            sx={{
              gridColumn: "1 / -1", // Span both columns
              display: "flex",
              gap: 2,
              mt: 4,
              zIndex: 1
            }}
          >
            <Link to="/" variant="body2">
              Home
            </Link>

            <Link to="/pricing" variant="body2">
              Pricing
            </Link>
    
            <Link to="/terms-of-service" variant="body2" target="_blank">
            Terms of Service
            
            </Link>
          </Box>
        </Box>

  {/* Background Triangle Content*/}
  <Box
    sx={{
      position: "fixed",     // Stick to screen corner
      bottom: 0,             // Align to bottom
      right: 0,              // Align to right
      zIndex: 1,
      pointerEvents: "none", // Allows clicks to pass through
      p: 2,                  // Optional padding
      display: { xs: "none", md: "block" } 
    }}
  > 
      <img src={MoneyBackGuaranteeImage} style={{height:'100px', paddingRight:'30px'}}/>

      <img src={CancelAnyTimeImage} style={{height:'100px', paddingRight:'30px'}}/>

      <img src={SecuredImage} style={{height:'100px'}}/>
      
  </Box>
  
{/* Bottom triangle */}
<Box
  sx={{
    position: 'fixed',
    bottom: 0,
    right: 0,
    width: 0,
    height: 0,
    borderLeft: '100vw solid transparent',
    borderBottom: '230px solid #1B263B',
    display: { xs: "none", md: "block" },
    zIndex: 0,
    pointerEvents: 'none', // So it doesn't block clicks
  }}
/>

    <Dialog open={openAcountHasEmailPasswordLoginDialog} onClose={() => setOpenAcountHasEmailPasswordLoginDialog(false)}>
      <DialogTitle>Email/Password Account Already Exists</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This email is already registered with a password. Please sign in using your password or use the "Forgot your password?" link if you need to reset it.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => setOpenAcountHasEmailPasswordLoginDialog(false)}
          sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>


    </Box>
  );
  
}
